import {createSvgIcon} from '../create-svg-icon';

export const MailIcon = createSvgIcon(
  <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z" />
, 'MailOutlined');
